import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import ShareViaStepIndicator from '../ShareViaStepIndicator';
import SharingMethodStepFooter from './SharingMethodStepFooter';
import SharingMethodStepContent from './SharingMethodStepContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SharingMethodStepContainer = () => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(UIDialogBody, {
      children: [/*#__PURE__*/_jsx(ShareViaStepIndicator, {}), /*#__PURE__*/_jsx(SharingMethodStepContent, {})]
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      children: /*#__PURE__*/_jsx(SharingMethodStepFooter, {})
    })]
  });
};
export default SharingMethodStepContainer;